import { Filter, Invoice, Pager } from './table-models';

/** Export-only scalar projection. All monetary values are in minor units. */
export interface TurnoverExportRow {
    responsibleUserIds?: number[];
    number: number | null;
    documentType: string | null;
    documentFailType: string | null;
    branchName: string | null;
    companyName: string | null;
    eik: string | null;
    userId: number | null;
    recordedBy: number | null;
    deviceCount: number;
    fromDate: string | null;
    duePaymentDate: string | null;
    invoiceDate: string | null;
    openingInvoiceDate: string | null;
    openingBalanceId: number | null;
    cash: number;
    paymentMethod: string | null;
    taskType: string | null;
    unpaidBank: boolean;
}

export interface TurnoverExportDTO {
    rows: TurnoverExportRow[];
    summary: Omit<TurnoverDTO, 'pager' | 'turnoverList'>;
}

export interface UserGroup {
    id: number;
    mainGroup: string;
    subGroup: string;
    timezone: string;
    language: string;
}

export interface LoggedUser {
    comment: string;
    creation_time: string;
    defaultView: DefaultView;
    email: string;
    group: Group;
    id: number;
    name: string;
    permissions: string[];
    phone: string;
    roles: string[];
    state: boolean;
    test_period: boolean;
    username: string;
}

export interface DefaultView {
    zoom: number;
    longitude: number;
    latitude: number;
}

export interface Group {
    id: number;
    mainGroup: string;
    subGroup: string;
    timezone: string;
    language: string;
}

export interface UserFull {
    id: number;
    comment: string;
    creation_time: string;
    defaultView: DefaultView;
    email: string;
    group: Group;
    name: string;
    permissions: string[];
    phone: string;
    roles: string[];
    state: boolean;
    test_period: boolean;
    username: string;
}

export interface UserFilter {
    searchBy?: string;
    roles?: string;
}

export const toUserFilter = (filter: Filter): UserFilter => {
    const roles = filter.tags.join(',');
    return { roles, searchBy: filter.search };
};

export interface MainGroup {
    mainGroup: string;
    subGroups: string[];
}

export interface DefaultView {
    center: {
        lat: number;
        lng: number;
    };
    zoom: number;
}
export interface Turnover {
    id: number;
    userId: number | null;
    cash: number;
    invoice: Invoice;
    createdAt: Date;
    paymentMethod: 'BANK' | 'CASH' | 'CARD';
    taskType: string;
    currency: string;
    /**
     * Издадена банкова фактура, по която парите още не са дошли. Такъв ред няма запис в оборота,
     * затова идва без `id` - няма какво да се изтрие, докато плащането не го роди.
     */
    unpaidBank: boolean;
    closedInvoicePayment?: boolean;
}
export interface DistributorSumTurnover {
    userId: number;
    cashInvoice: number;
    bankInvoice: number;
    cashReceipt: number;
    bankReceipt: number;
}
export interface DistributorTurnover {
    userId: number | null;
    sum: number;
    currentSum: number;
    openingSum: number;
    paidCashSum: number;
    paidCardSum: number;
    paidBankSum: number;
}
export interface TotalTurnoverReport {
    payments: DistributorSumTurnover[]
    after: Date,
    before: Date
}
export interface TurnoverDTO {
    sum: number;
    paidCashSum: number;
    paidCardSum: number;
    paidBankSum: number;
    /** Дължимото по издадени банкови фактури. */
    unpaidBankSum: number;
    unpaidOpeningSum: number;
    paidOpeningSum: number;
    paidBankCurrentSum: number;
    unpaidBankCurrentSum: number;
    turnovers: DistributorTurnover[];
    turnoverList: Turnover[];
    pager: Pager;
}

export interface MonthlyReport {
    branchCount: number;
    deviceCount: number;
    month: Date;
}
